import { render, staticRenderFns } from "./FamilyRequest.vue?vue&type=template&id=b6f2ff42&scoped=true&"
import script from "./FamilyRequest.vue?vue&type=script&lang=js&"
export * from "./FamilyRequest.vue?vue&type=script&lang=js&"
import style0 from "./FamilyRequest.vue?vue&type=style&index=0&id=b6f2ff42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6f2ff42",
  null
  
)

export default component.exports